import React from "react";
import { Avatar, CircularProgress, Button } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import DualBall from "../../../utilities/dual ball back.svg";

// Format a joining date like "Jan 12, 2024"; fall back gracefully on bad/empty input.
const formatJoined = (val) => {
  if (!val) return "-";
  const d = new Date(val);
  if (isNaN(d.getTime())) return String(val).slice(0, 10);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

/**
 * Presentational profile sub-sidebar for the My Profile redesign.
 * Owns no business state - all data, toggles, handlers and avatar-upload
 * state live in PersonalDetails and are passed down as props.
 */
const ProfileSidebar = (props) => {
  const {
    Employee,
    user,
    showPersonal,
    showSalary,
    showDocuments,
    showManager,
    showRequestedChanges,
    showLeaves,
    onPersonal,
    onSalary,
    onDocuments,
    onManager,
    onRequested,
    onLeaves,
    isImageLoading,
    profilePicture,
    uploadbtnshow,
    loader,
    onFileChange,
    onUpload,
    onImageLoad,
  } = props;

  const isHrOrExec = user?.role === "HR" || user?.role === "Executive";
  const realPic =
    Employee?.profilepic && Employee.profilepic !== "https://via.placeholder.com/250"
      ? Employee.profilepic
      : null;
  const initial = Employee?.name ? Employee.name[0] : "";

  const tabs = [
    { key: "personal", label: "Personal", icon: <PersonOutlineIcon />, active: showPersonal, onClick: onPersonal, show: true },
    { key: "salary", label: "Salary", icon: <PaymentsOutlinedIcon />, active: showSalary, onClick: onSalary, show: true },
    { key: "documents", label: "Documents", icon: <DescriptionOutlinedIcon />, active: showDocuments, onClick: onDocuments, show: true },
    { key: "manager", label: "Manager Tab", icon: <GroupsOutlinedIcon />, active: showManager, onClick: onManager, show: true },
    { key: "requested", label: "Requested Changes", icon: <EditNoteOutlinedIcon />, active: showRequestedChanges, onClick: onRequested, show: true },
    { key: "leaves", label: "Leaves", icon: <EventNoteOutlinedIcon />, active: showLeaves, onClick: onLeaves, show: isHrOrExec },
  ];

  return (
    <aside className="profileSidebar">
      <div className="profileCard">
        <div className="profileCardGlow" />
        <label htmlFor="upload-photo" className="profileAvatarWrap">
          <input
            type="file"
            id="upload-photo"
            style={{ display: "none" }}
            onChange={onFileChange}
          />
          {isImageLoading ? (
            <CircularProgress />
          ) : profilePicture ? (
            <img
              src={profilePicture}
              alt="Profile"
              className="profileAvatarImg"
              onLoad={onImageLoad}
            />
          ) : (
            <Avatar className="profileAvatar" src={realPic || undefined}>
              {!realPic && initial}
            </Avatar>
          )}
        </label>

        <h2 className="profileName">{Employee?.name || ""}</h2>
        {Employee?.pos && <div className="profileRole">{Employee.pos}</div>}

        {Employee?.department && (
          <div className="profileChips">
            <span className="profileChip">
              <GroupOutlinedIcon sx={{ fontSize: 14 }} />
              {Employee.department}
            </span>
          </div>
        )}

        {uploadbtnshow && (
          <Button
            variant="outlined"
            size="small"
            className="profileUploadBtn"
            onClick={onUpload}
          >
            Upload Photo
          </Button>
        )}
        {loader && (
          <img className="dual-ball" src={DualBall} alt="Uploading" width="54" height="54" />
        )}
      </div>

      <div className="profileDivider" />

      <nav className="profileNav">
        <div className="profileNavLabel">Profile Sections</div>
        {tabs
          .filter((t) => t.show)
          .map((t) => (
            <button
              key={t.key}
              onClick={t.onClick}
              className={`profileNavBtn ${t.active ? "profileNavBtn--active" : ""}`}
            >
              <span className="profileNavIcon">{t.icon}</span>
              <span className="profileNavText">{t.label}</span>
            </button>
          ))}
      </nav>

      <div className="profileJoined">
        <div className="profileJoinedCard">
          <span className="profileJoinedIcon">
            <CalendarMonthOutlinedIcon sx={{ fontSize: 17 }} />
          </span>
          <div>
            <div className="profileJoinedLabel">Joined</div>
            <div className="profileJoinedValue">{formatJoined(Employee?.joining)}</div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ProfileSidebar;
